import { render, staticRenderFns } from "./verify.vue?vue&type=template&id=220ce6ac&"
import script from "./verify.vue?vue&type=script&lang=ts&"
export * from "./verify.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports